import { api } from '@/api/http'

// 회원 정보 조회 — 레거시 DlgPwSettings.show()/admin_show()
//   GET api/get_member?m_id={mId}
//   응답: { check, info: { id, email, name, department, mobile_phone_number, type, authority_type,
//                          register_datetime, status, sms_yn, c_id, c_name, ... } }
export async function getMember(mId, signal) {
  const { data } = await api.get('api/get_member', {
    params: { m_id: mId },
    signal,
  })
  return data
}

// 회원 정보 수정 — 레거시 handleOk()
//   POST api/users/update_member  body={id, fields=URI(JSON.stringify(diff))}
//   변경된 필드만 전송 (호출측에서 diff 계산 후 fields 객체로 전달)
export async function updateMember(id, fields, signal) {
  const params = new URLSearchParams()
  params.set('id', String(id))
  params.set('fields', encodeURIComponent(JSON.stringify(fields || {})))
  const { data } = await api.post('api/users/update_member', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    signal,
  })
  return data
}

// 비밀번호 변경 — 레거시 pw_change()
//   POST api/reset_pw_member  body={id, pw}
export async function resetPwMember(id, pw, signal) {
  const params = new URLSearchParams()
  params.set('id', String(id))
  params.set('pw', String(pw))
  const { data } = await api.post('api/reset_pw_member', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    signal,
  })
  return data
}

// SMS 설정 — 레거시 sms_update()
//   POST api/users/set_sms_setting  body={sms_active, customer_id, customer_member_id, mobile, user_name}
export async function setSmsSetting(payload, signal) {
  const params = new URLSearchParams()
  Object.entries(payload || {}).forEach(([k, v]) => {
    if (v != null) params.set(k, String(v))
  })
  const { data } = await api.post('api/users/set_sms_setting', params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    signal,
  })
  return data
}
